import { BaseConfig } from '../ServiceConfig';

export interface CovBffConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.CovBffServiceConfigData';
  url: string;
  detailUrl: string;
  returnUrl: string;
}

export const CovBffConfigurationFields: (keyof CovBffConfiguration)[] = [
  'url',
  'detailUrl',
  'returnUrl',
];

export const BlankCovBffConfiguration: CovBffConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.CovBffServiceConfigData',
} as CovBffConfiguration;
